import {
  type BaseFlowBlock,
  type FlowBlockType,
  FlowOcrMethod,
  type FlowProducedType,
} from 'flow-schema';

// @deprecated
export interface OcrBlock extends BaseFlowBlock<FlowProducedType.Any> {
  type: FlowBlockType.Ocr;
  config: {
    gsPaths: {
      gsPath: string;
    }[];
  };
}

export const RECOMMENDED_OCR_METHOD = FlowOcrMethod.VisionLanguageModel;
